import React from "react";
import "./AttachmentCard.scss";

interface AttachmentCardProps {
  title: string;
  onDelete?: () => void;
  className?: string;
  uploadProgress?: number; // 0 to 100
  isUploading?: boolean;
}

export const AttachmentCard: React.FC<AttachmentCardProps> = ({
  title,
  onDelete,
  className = "",
  uploadProgress = 0,
  isUploading = false,
}) => {
  return (
    <div
      className={`attachment-card ${
        isUploading ? "uploading" : ""
      } ${className}`}
    >
      <span className="title">{title}</span>
      <div className="right-content">
        {isUploading ? (
          <>
            <span className="upload-text">Uploading</span>
            <button
              className="close-button"
              onClick={onDelete}
              aria-label="Cancel upload"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15 5L5 15M5 5L15 15"
                  stroke="#CC0200"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </>
        ) : (
          <button
            className="delete-button"
            onClick={onDelete}
            aria-label="Delete attachment"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.16667 5.83334H15.8333M8.33333 9.16667V14.1667M11.6667 9.16667V14.1667M5 5.83334L5.83333 15.8333C5.83333 16.2754 6.00893 16.6993 6.32149 17.0119C6.63405 17.3244 7.05797 17.5 7.5 17.5H12.5C12.942 17.5 13.366 17.3244 13.6785 17.0119C13.9911 16.6993 14.1667 16.2754 14.1667 15.8333L15 5.83334M7.5 5.83334V3.33334C7.5 3.11232 7.5878 2.90036 7.74408 2.74408C7.90036 2.5878 8.11232 2.5 8.33333 2.5H11.6667C11.8877 2.5 12.0996 2.5878 12.2559 2.74408C12.4122 2.90036 12.5 3.11232 12.5 3.33334V5.83334"
                stroke="#CC0200"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        )}
      </div>
      {isUploading && (
        <div
          className="upload-progress"
          style={{ width: `${uploadProgress}%` }}
          role="progressbar"
          aria-valuenow={uploadProgress}
          aria-valuemin={0}
          aria-valuemax={100}
        />
      )}
    </div>
  );
};
